export const inventoryRoute = {
  INVENTORY_MAIN: '/inventory',
  INVENTORY_REPORT: '/inventory/summary',
  INVENTORY_STOCK_ADJUSTMENT: '/inventory/stock-adjustment',
}
